<template>
  <div>
    <b-overlay :show="loading">
      <b-row cols="1">
        <b-col class="my-3 px-0">
          <p class="text-center fw-bolder">
            Per proseguire è necessario
            <span
              target="_blank"
              class="point"
              @click="$bvModal.show('informativa_arruolamento')"
            >
              <u> leggere e prendere visione dell'informativa</u></span
            >.
            <!-- <a
            href="/assets/informativa_profilo_sanitario_arruolamento.pdf"
            target="_blank"
            ><span class="point underlined text-prim-grad-1 fw-bolder"
              >Stampa informativa</span
            ></a
          > -->
            <br />
          </p>
          <b-form-checkbox
            class="text-font-light-grey"
            name="data_read_consense"
            :value="true"
            :unchecked-value="false"
            v-model="informRead"
            :state="informRead == true"
          >
            Ho letto e compreso
            <span
              target="_blank"
              class="point"
              @click="$bvModal.show('informativa_arruolamento')"
            >
              <u>l'informativa privacy</u></span
            >
          </b-form-checkbox>
          <b-form-checkbox
            class="text-font-light-grey"
            name="data_consense"
            :value="true"
            :unchecked-value="false"
            v-model="informAccepted"
            :state="informAccepted == true"
          >
            Acconsento al trattamento dei miei dati personali per la
            condivisione con il farmacista di dati relativi alla mia salute
          </b-form-checkbox>
          <b-form-checkbox
            class="text-font-light-grey"
            name="data_consense_second"
            :value="true"
            :unchecked-value="false"
            v-model="informAccepted2"
            :state="informAccepted2 == true"
          >
            Acconsento al trattamento dei miei dati personali per la valutazione
            della mia aderenza terapeutica con finalità di sensibilizzazione
          </b-form-checkbox>
        </b-col>
        <div class="col-12 text-center mt-3">
          <b-button
            type="button"
            variant="outline-secondary mx-2"
            @click="$router.push({ name: 'Home' })"
            >Indietro
          </b-button>
          <b-button
            @click="handleConfirm"
            variant="primary text-white primary_gradient mx-2"
            :disabled="!informRead"
            >Conferma le mie scelte
          </b-button>
        </div>
        <div></div>
      </b-row>
    </b-overlay>
    <b-modal
      centered
      size="lg"
      id="delete-confirm"
      title="Elimina profilo"
      ok-title="Sì, elimina"
      ok-variant="danger fw-bolder spacing_1"
      cancel-title="No, annulla"
      cancel-variant="outline-primary fw-bolder spacing_1"
      footer-border-variant="white"
      footer-class="text-center"
      @cancel="$bvModal.hide('delete-confirm')"
      @ok="submitDelete"
    >
      <div class="px-4">
        <h5>
          Il consenso al trattamento dati per la condivisione con il farmacista
          è necessario per l'utilizzo della piattaforma; il tuo profilo verrà
          dunque cancellato. Sei sicuro di voler eliminare il tuo profilo?
        </h5>
        <p>
          Una volta confermata l'eliminazione non potrai più tornare indietro.
        </p>
      </div>
    </b-modal>
    <b-modal
      size="xl"
      centered
      id="informativa_arruolamento"
      title="Informativa Profilo Sanitario"
      hide-footer
    >
      <InformativaArruolamento
        v-bind="
          user.arruolato && companyArruolante
            ? { company: companyArruolante }
            : {}
        "
      ></InformativaArruolamento>
    </b-modal>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import InformativaArruolamento from "@/components/pazienti/InformativaArruolamento.vue";
import { cittadinoService, utilityService } from "@/_services";
export default {
  name: "AccettaInformativaProfiloSanitario",
  components: {
    InformativaArruolamento,
  },
  computed: {
    ...mapState("utente", ["status", "user"]),
  },
  data() {
    return {
      informAccepted: false,
      informAccepted2: false,
      informRead: false,
      loading: false,
      informativa: {
        0: {
          text: " informativa cittadino",
          url: "info_cittadino",
        },
        1: {
          text: " informativa farmacista",
          url: "info_farmacista",
        },
      },
      tc: {
        0: {
          text: " tc cittadino",
          url: "tc_cittadino",
        },
        1: {
          text: " tc farmacista",
          url: "tc_farmacista",
        },
      },
      companyArruolante: null,
    };
  },
  methods: {
    ...mapActions("utente", ["me", "deleteProfile", "setAnagrafica"]),
    ...mapActions({
      clearAlert: "alert/clear",
      infoAlert: "alert/info",
      successAlert: "alert/success",
      errorAlert: "alert/error",
    }),
    handleConfirm() {
      if (this.informAccepted == false) {
        return this.$bvModal.show("delete-confirm");
      } else {
        this.updateConsense();
      }
    },
    submitDelete() {
      const self = this;
      this.deleteProfile().then(function () {
        window.scrollTo(0, 0);
        self.$bvModal["delete-confirm"].hide();
      });
    },
    updateConsense() {
      this.loading = true;
      const self = this;
      const form = {
        profilo_sanitario_pp: this.informAccepted,
        profilo_sanitario_concesso: this.informAccepted2,
      };
      cittadinoService
        .updateConsense(form)
        .then(function (res) {
          window.scrollTo(0, 0);
          self.successAlert("Preferenze salvate correttamente");
          self.me();
        })
        .catch(function (err) {
          window.scrollTo(0, 0);
          self.errorAlert("Non è stato possibile salvare le preferenze");
          self.loading = false;
        });
    },
    getCompanyArruolante() {
      utilityService
        .getArruolatoBy(this.user.hashid)
        .then((res) => {
          if (res.data.data) {
            this.companyArruolante = res.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.me();
  },
  mounted() {
    if (this.user.arruolato) {
      this.getCompanyArruolante();
    }
  },
};
</script>
